module.exports = __webpack_public_path__ + "static/media/iconNoText.71827592.png";